/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiParentStudentsAccountUserIdDelete$Params {
  userId: string;
  institutionId?: string;
}

export function apiParentStudentsAccountUserIdDelete(http: HttpClient, rootUrl: string, params: ApiParentStudentsAccountUserIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiParentStudentsAccountUserIdDelete.PATH, 'delete');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.query('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiParentStudentsAccountUserIdDelete.PATH = '/api/parent-students/account/{userId}';
